import * as _actions from './actions';
import _reducer from './reducer';
import _StudentReportSummary from './model';

_StudentReportSummary.actions = _actions;

export const actions = _actions;
export const reducer = _reducer;
export const StudentReportSummary = _StudentReportSummary;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/index.js